// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"c56f81d7","861":"656f4d4a"}[chunkId] + ".chunk.js";
};